import React from 'react';
import classNames from 'classnames';
import { differenceInYears } from 'date-fns';
import { formatDate } from 'twain-sport-fe-mono/utils/formatDate';
import { EMPTY_SPACE } from 'twain-sport-fe-mono/constants/textSymbols';
import { DateTime } from 'twain-sport-fe-mono/enums/DateTime';
import { IParticipantBannerDetails } from 'twain-sport-fe-mono/interfaces/IParticipant';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import classes from './InfoBox.module.scss';

interface IProps {
    participant: IParticipantBannerDetails;
    className?: string;
    locale?: Locale;
}

export const InfoBox: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const info = [
        {
            key: 'age',
            title: translationProvider.string('age'),
            value: props.participant.birthDate
                ? differenceInYears(Date.now(), new Date(props.participant.birthDate))
                : '-',
        },
        {
            key: 'weight',
            title: translationProvider.string('weight'),
            value: Number(props.participant.weight),
            suffix: translationProvider.string('kg'),
        },
        {
            key: 'height',
            title: translationProvider.string('height'),
            value: Number(props.participant.height),
            suffix: translationProvider.string('cm'),
        },
        {
            key: 'birthDate',
            title: translationProvider.string('birth_date'),
            value: props.participant.birthDate
                ? formatDate(
                      new Date(props.participant.birthDate),
                      DateTime.DATE_FORMAT,
                      props.locale
                          ? {
                                locale: props.locale,
                            }
                          : null,
                  )
                : '-',
        },
    ];

    return (
        <div className={classNames(classes.container, props.className)}>
            {info.map((infoItem) => (
                <div
                    className={classes.row}
                    key={infoItem.key}
                    data-qa={`block-profile-info-${infoItem.key}`}
                >
                    <div className={classes.title} data-qa="title-profile-infoTitle">
                        {infoItem.title}:
                    </div>
                    <div className={classes.value} data-qa="title-profile-infoValue">
                        <b>{infoItem.value}</b>
                        {EMPTY_SPACE}
                        <span>{infoItem.suffix || ''}</span>
                    </div>
                </div>
            ))}
            {props.children}
        </div>
    );
};
